/* eslint-disable no-plusplus */
import { ISearchOptions } from '../SearchAddon';
import Mark from './Mark';

const MAX_COUNT = 1000;
export default class Searcher {
  private options: {
    markClassName?: string;
    markedClassName?: string;
  };

  constructor(
    options = {
      markClassName: 'terminal-viewer-hl-mark',
      markedClassName: 'terminal-viewer-hl-mark terminal-viewer-hl-marked',
    },
  ) {
    this.options = options;
  }

  search(
    keyword: string,
    logs: Array<string>,
    hlIndex = 0,
    options: ISearchOptions | undefined = undefined,
  ) {
    if (!Array.isArray(logs) || logs.length === 0 || !keyword) {
      return {
        count: 0,
        map: {},
        markedKey: 0,
      };
    }
    const { markClassName, markedClassName } = this.options;
    const style = {
      color: options?.decorations?.matchForegroundColor,
      background: options?.decorations?.matchBackground,
      border: options?.decorations?.matchBorder,
    };
    const markedStyle = {
      background: options?.decorations?.activeMatchBackground,
      border: options?.decorations?.activeMatchBorder,
    };
    let count = 0;
    let markedId = 0;
    const map: { [key: string | number]: string } = {};
    for (let i = 0, len = logs.length; i < len; i++) {
      if (count >= MAX_COUNT) {
        break;
      }
      const text = logs[i] || '';
      if (!text.toLowerCase().includes(keyword.toLowerCase())) {
        // eslint-disable-next-line no-continue
        continue;
      }
      let mark: Mark | null = new Mark(text, {
        className: markClassName,
        markedClassName,
        style,
        markedStyle,
      });
      const markedText = mark
        .mark(keyword, {
          matchedIndex: count,
          hlIndex,
        })
        .toString();
      if (mark.isMarked) {
        markedId = i;
      }
      if (mark.matchCount !== 0) {
        count += mark.matchCount;
        map[i] = markedText || text;
      }
      mark.distory();
      mark = null;
    }
    return {
      count,
      map,
      markedKey: markedId,
    };
  }
}
